
<div>
    <app-bar :title="athlete.name"/>

    <v-layout>
        <v-progress-linear
            v-if="overlay"
            absolute
            indeterminate
        ></v-progress-linear>

        <div class="pt-8 pb-12 px-8">
            <div class="pb-10">
                <v-btn
                    v-if="permitted('admin_club_management')"
                    @click="edit"
                    class="sm mr-5"
                    color="primary"
                >{{ t('general_action_edit') }}
                </v-btn>
                <confirm-modal
                    v-if="permitted('admin_club_management')"
                    :title="t('general_title_confirm_action')"
                    @agree="del(athlete)"
                >
                    <template #default="{ on, attrs }">
                        <v-btn
                            class="sm"
                            color="orange"
                            outlined
                            v-on="on"
                            v-bind="attrs"
                        >{{ t('general_action_delete') }}</v-btn>
                    </template>
                </confirm-modal>
            </div>
            <div class="float-left mr-10" style="width: 200px; max-width: 200px">
                <img
                    v-if="athlete.photoUrl"
                    :src="athlete.photoUrl"
                    width="200"
                />
                <div v-if="athlete.link" class="form-subtitle">{{ t('club_athlete_label_link') }}:</div>
                <div v-if="athlete.link" class="form-subtitle-description">{{ athlete.link }}</div>
                <div v-if="linkParamRows().length" class="form-subtitle">{{ t('club_athlete_label_link_params') }}:</div>
                <div v-if="linkParamRows().length" class="form-subtitle-description">
                    <div v-for="row in linkParamRows()" :key="row.key">{{ row.key }}: {{ row.value }}</div>
                </div>
            </div>
            <div class="float-left" style="max-width: calc(100% - 240px)">
                <card-unit :items="items()">
                    <template #title>{{ t('club_athlete_label_id') }}: {{ athlete.id }}</template>
                </card-unit>
            </div>
        </div>
    </v-layout>
</div>
